import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetMemberList from '@/modules/manage-member/api/hooks/useQueryGetMemberList'
import ManageMemberListing from '@/modules/manage-member/components/ManageMember/components/ManageMemberListing'

function ManageMemberPage() {
	const { pageSize, currentPage, searchQuery, selectedQuery } =
		useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		username: searchQuery,
		userGroupId: selectedQuery || undefined,
	}

	const { data, isLoading } = useQueryGetMemberList(payload)

	return (
		<PageContainer>
			<ManageMemberListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedManageMemberPage = withUserPermission(ManageMemberPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_OPERATOR],
})
export default GuardedManageMemberPage
